var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal',{attrs:{"to":"root"}},[_c('div',{class:[
			'c-dropcursor',
			_vm.position,
			{ centered: _vm.isCentered === true },
			{ active: _vm.active === true } ],style:(_vm.dropcursorStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }